import { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import useTranslation from '../../../../hooks/useTranslations';
import { selectSearchString } from '../../../../redux/modules/searchSlice';
import { NewsIcon, OlympusLogoIcon, SearchGlassIcon, StarIcon } from '../../../misc/icons/Icons';
import Inputfield from '../../../misc/Inputfield';
import FeedbackModal from '../../general/FeedbackModal';
import LanguageModal from '../../general/LanguageModal';
import MobileNavigation from '../../navigation/MobileNavigation';
import UserMenu from '../../navigation/UserMenu';

const TopBar = ({ activeTree, customTree }) => {
	const t = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const searchString = useSelector((state) => selectSearchString(state));
	const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
	const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);

	return (
		<>
			<div className="fixed top-0 left-0 right-0 z-40 flex justify-center flex-shrink-0 w-screen h-12 bg-white shadow lg:h-24 print:hidden">
				<nav className="flex-1 max-w-[1920px] relative items-center flex">
					<div className="flex-1 px-2.5">
						<div className="flex items-center justify-between">
							<NavLink
								to="/"
								className="flex items-center w-auto py-2 pr-4 lg:flex-shrink-0 lg:px-10 lg:py-0"
							>
								<OlympusLogoIcon className="w-40 h-8" />
							</NavLink>
							<div className="justify-end flex-1 hidden px-2 ml-6 mr-6 lg:flex">
								<div className="w-full max-w-sm">
									<Inputfield fieldName="search" label={t('general_search')} icon={<SearchGlassIcon className="w-6 h-6" />} initialValue={searchString} handleChange={(newSearchString) => history.push(`/search/${newSearchString}`)} useDebounce autoFocus={location?.pathname?.includes('search') ?? false} />
								</div>
							</div>
							<div className="flex justify-between flex-shrink-0 lg:flex-shrink-1 w-52 lg:w-auto">
								<div className="flex text-oly-blue-dark lg:mr-6">
									<NavLink
										to="/news"
										activeClassName="ring-2 ring-oly-blue-dark bg-gray-50"
										className="flex flex-row w-full px-3 py-3 text-[1.0625rem] font-semibold text-left transition duration-150 ease-in-out lg:py-2 can-hover:lg:hover:ring-2 can-hover:lg:hover:ring-oly-blue-dark can-hover:hover:bg-gray-50 focus:outline-none lg:focus-visible:ring-2 lg:focus-visible:ring-oly-blue-dark focus-visible:bg-gray-50"
									>
										<div className="relative">
											<NewsIcon className="w-6 h-6 lg:mr-2" />
											{/* <AlertIcon className="absolute top-0 right-0 w-4 h-4 -mt-1 -mr-2 lg:mr-0 text-oly-red-default" /> */}
										</div>
										<span className="hidden lg:inline">{t('news_button')}</span>
									</NavLink>
								</div>
								<div className="flex text-oly-blue-dark lg:mr-6">
									<NavLink
										to="/favorites"
										activeClassName="ring-2 ring-oly-blue-dark bg-gray-50"
										className="flex flex-row w-full px-3 py-3 text-[1.0625rem] font-semibold text-left transition duration-150 ease-in-out lg:py-2 can-hover:lg:hover:ring-2 can-hover:lg:hover:ring-oly-blue-dark can-hover:hover:bg-gray-50 focus:outline-none lg:focus-visible:ring-2 lg:focus-visible:ring-oly-blue-dark focus-visible:bg-gray-50"
									>
										<StarIcon className="w-6 h-6 lg:mr-2" />
										<span className="hidden lg:inline">{t('tab_favorite_lists')}</span>
									</NavLink>
								</div>
								<UserMenu setIsFeedbackModalOpen={setIsFeedbackModalOpen} setIsLanguageModalOpen={setIsLanguageModalOpen} />
								<div className="flex lg:hidden">
									<MobileNavigation activeTree={activeTree} customTree={customTree} />
								</div>
							</div>
						</div>
					</div>
				</nav>
			</div>
			{isFeedbackModalOpen && <FeedbackModal isFeedbackModalOpen={isFeedbackModalOpen} setIsFeedbackModalOpen={setIsFeedbackModalOpen} />}
			{isLanguageModalOpen && <LanguageModal isLanguageModalOpen={isLanguageModalOpen} setIsLanguageModalOpen={setIsLanguageModalOpen} />}
		</>
	);
};

export default TopBar;
